import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Popover as TinyPopover, ArrowContainer } from 'react-tiny-popover';

import styles from './styles.module.scss';

export default function Popover(props) {
  const classes = classNames(props.containerClassName, styles.popover);

  return (
    <TinyPopover
      padding={5}
      boundaryInset={12}
      positions={['left', 'bottom', 'top', 'right']}
      {...props}
      containerClassName={classes}
      content={({ position, childRect, popoverRect }) => {
        return (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowSize={10}
            arrowColor={'#ced4da'}
            arrowStyle={{ opacity: 0.9 }}
          >
            <div className={styles.wrapper}>{props.content}</div>
          </ArrowContainer>
        );
      }}
    >
      {props.children}
    </TinyPopover>
  );
}

Popover.propTypes = {
  content: PropTypes.node,
  children: PropTypes.node,
  containerClassName: PropTypes.string
};
